export enum PatientIdentifierType {
    Document = 'document',
    National = 'national'
}